'use es6';

import AdWordsTemplateAdEntityRecord from 'AdsUI/records/ad-management/AdWordsTemplateAdEntityRecord';
import AdWordsTextAdEntityRecord from 'AdsUI/records/ad-management/AdWordsTextAdEntityRecord';
import { AdWordsAdTypes } from 'AdsUI/lib/Constants';

const removeUndefinedProperties = (source = {}) => {
  return Object.keys(source).reduce((output, key) => {
    if (source[key]) {
      output[key] = source[key];
    }

    return output;
  }, {});
};

const buildAdWordsAdRecord = (adType, adProps = {}) => {
  const {
    id,
    status,
    adGroupId,
    network,
    accountId,
    campaignId,
    mobile,
    description1,
    description2,
    displayUrl,
    finalUrl,
    headline,
    appId,
    appStore,
    trackingUrlTemplate
  } = adProps;
  const baseFields = {
    id,
    adGroupId,
    status,
    adType,
    finalUrl,
    displayUrl,
    network,
    accountId,
    campaignId
  }; // Common for non-expanded text ads

  const textFields = removeUndefinedProperties(Object.assign({}, baseFields, {
    headline,
    description1,
    description2,
    mobile
  }));

  switch (adType) {
    case AdWordsAdTypes.TEXT_AD:
      return AdWordsTextAdEntityRecord(textFields);

    case AdWordsAdTypes.TEMPLATE_AD:
    default:
      {
        const templateAdFields = removeUndefinedProperties(Object.assign({}, textFields, {
          appId,
          appStore,
          trackingUrlTemplate
        }));
        return AdWordsTemplateAdEntityRecord(templateAdFields);
      }
  }
};

const AdWordsAdEntityRecord = adProps => buildAdWordsAdRecord(adProps.adType, adProps);

export default {
  buildAdWordsAdRecord,
  AdWordsAdEntityRecord
};